import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, onClose, errorMessage }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          margin: 2,
        },
      }}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <h2 className="text-lg font-semibold">{t('SORRY')}</h2>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </div>

      {/* Content */}
      <DialogContent sx={{ padding: '16px' }}>
        <div className="flex flex-col gap-5">
          <p className="text-gray-700 mb-4">{t(errorMessage) || errorMessage}</p>

          {/* Close Button */}
          <Button onClick={onClose} type="submit">
            {t('TRY_AGAIN')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorModal;
